/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';

import { TOverlayOptions } from '../../core/types';
import {
    OVERLAY_DIALOG_SET_IS_CARET_VISIBLE,
    SET_OVERLAY_DIALOG_OPTIONS,
    SET_OVERLAY_DIALOG_STATE,
    SET_OVERLAY_DIALOG_TIMER_ID,
} from './overlaydialog.types';
import { IOverlayDialog } from './overlaydialogprops';

export const setOverlayDialogStateAction = (
    uiProperties: IOverlayDialog,
    isOverlayDialogActive: boolean,
): AnyAction => ({
    type: SET_OVERLAY_DIALOG_STATE,
    payload: {
        uiProperties,
        isOverlayDialogActive,
    },
});

export const setOverlayDialogTimerIdAction = (timerId): AnyAction => ({
    type: SET_OVERLAY_DIALOG_TIMER_ID,
    payload: {
        timerId,
    },
});

export const setOverlayDialogOptionsAction = (options: TOverlayOptions[]): AnyAction => ({
    type: SET_OVERLAY_DIALOG_OPTIONS,
    payload: {
        options,
    },
});

export const overlayDialogSetIsCaretVisibleAction = (isCaretVisible: boolean): AnyAction => ({
    type: OVERLAY_DIALOG_SET_IS_CARET_VISIBLE,
    payload: {
        isCaretVisible,
    },
});
